export default function open ({ next, store, router }) {
  return next()
}
